import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { ProductCreateFoodcostImagePage } from "../product-create-foodcost-image/product-create-foodcost-image";
import { ProductsServices } from "../../../services";
import { Globals } from '../../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../../stock/stock-list/stock-list';

/**
 * Generated class for the ProductCreateFoodcostPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-create-foodcost-preparation',
    templateUrl: 'product-create-foodcost-preparation.html',
})
export class ProductCreateFoodcostPreparationPage {
    update_state: boolean = false;
    product_uid: any;
    recipe: string = '';
    tools: string = '';
    time: string = '';
    product_name: string;
    product: any;
    time_cooking: string = '';
    difficulty: string = '';
    //
    _recipe: string = '';
    _tools: string = '';

    show_alert: boolean = true;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public productsServices: ProductsServices,
        public globals: Globals,
        public translate: TranslateService,
        private alertCtrl: AlertController,) {

        this.update_state = this.navParams.get('update_state');
        this.product_uid = this.navParams.get('product_uid');
        this.product_name = this.navParams.get('product_name');
        this.product = this.navParams.get('product');

        if (this.update_state) {
            this.recipe = this.navParams.get('recipe');
            this.tools = this.navParams.get('tools');
            this.time = this.navParams.get('time');
            this._recipe = this.navParams.get('recipe');
            this._tools = this.navParams.get('tools');
            this.time_cooking = this.navParams.get('time_cooking');
            this.difficulty = this.navParams.get('difficulty');
        }


    }

    ionViewCanLeave(): Promise<void> {
        return new Promise((resolve, reject) => {
            //Si el show_alert es true i no estem fen un update al plat
            if (this.show_alert && !this.update_state) {
                let alert = this.alertCtrl.create({
                    title: this.translate.instant('general-atencion'),
                    message: this.translate.instant('general-salir-proceso-creacion'),
                    subTitle: this.translate.instant('general-se-eliminara-elemento'),
                    buttons: [
                        {
                            text: this.translate.instant('general-no'),
                            role: 'cancel',
                            handler: () => {
                                this.globals.side_menu_active = 'stock';
                                reject();
                            },
                        },
                        {
                            text: this.translate.instant('general-si'),
                            handler: () => {
                                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                                resolve();
                                this.navCtrl.setRoot(StockListPage);
                            },
                        },
                    ],
                });
                alert.present();
            } else {
                resolve();
            }
        });
    }

    getInitRecipe(editor: any) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.recipe = editor.html;
            } else {
                this.recipe = '';
            }
        }
    }

    getInitTools(editor: any) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.tools = editor.html;
            } else {
                this.tools = '';
            }
        }
    }

    update() {
        this.show_alert = false;
        if (!this.recipe) {
            this.recipe = '';
        }
        if (!this.tools) {
            this.tools = '';
        }
        if (!this.time) {
            this.time = '';
        }

        if (!this.time_cooking) {
            this.time_cooking = '';
        }

        if (!this.difficulty) {
            this.difficulty = '';
        }

        this.productsServices.afs.collection('products').doc(this.product_uid).update({
            'recipe': this.recipe,
            'time': this.time,
            'tools': this.tools,
            'time_cooking': this.time_cooking,
            'difficulty': this.difficulty,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            if (this.update_state) {
                this.globals.GAtrackView('Products', 'Products - Preparation - Update', this.globals.restaurant.email, 'Create/Update', 'Update preparation', 'Products', this.product_name);
                //
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Products', 'Products - Preparation - Create', this.globals.restaurant.email, 'Create/Update', 'Create preparation', 'Products', this.product_name);
                //
                this.navCtrl.push(ProductCreateFoodcostImagePage, {
                    update_state: this.update_state,
                    product_uid: this.product_uid,
                    product_name: this.product_name
                })
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-preparation/product-create-foodcost-preparation.ts